
import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

import BoxFilterComponent from "./filter.box";
import CloudFilterComponent from "./filter.cloud";
import DemoFilterComponent from "./filter.demo";

export default class Web extends mixin(environment.nexus, {
  box: BoxFilterComponent,
  cloud: CloudFilterComponent,
  demo: DemoFilterComponent,
}) { }
